var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"d-flex flex-column align-items-center justify-content-center bg-light"},[_c('div',{staticClass:"text-muted"},[_vm._v("\n    © "+_vm._s(_vm.appName)+" "+_vm._s(_vm.year)+"\n  ")]),_vm._v(" "),_c('router-link',{attrs:{"to":{name: 'feedback'}}},[_vm._v("\n    Suggest Feature / Report Bug\n  ")])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-49128836","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/AppFooter.vue
// module id = null
// module chunks = 